import { ThemeProvider } from './theme.context';

export default ThemeProvider;
